import Box from "@material-ui/core/esm/Box";
import Divider from "@material-ui/core/esm/Divider";
import AddIcon from "@material-ui/icons/esm/Add";
import { nanoid } from 'nanoid';
import React, { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilState } from 'recoil';
import { SecondaryButton } from 'components/Button';
import InfoBox from 'components/InfoBox/InfoBox';
import { Title } from 'components/Text';
import useOrderTag from 'hooks/tags/useOrderTag';
import { vehicleFormIdsToRegister as vehicleFormIdsToRegisterAtom, vehiclesToRegister as vehiclesToRegisterAtom } from 'state/vehicles';
import ChooseSingleVehicle from './ChooseSingleVehicle';
export default function ChooseVehicles() {
  const {
    t
  } = useTranslation();
  const {
    vehiclesUnique
  } = useOrderTag();
  const [vehicleFormIdsToRegister, setVehicleFormIdsToRegister] = useRecoilState(vehicleFormIdsToRegisterAtom);
  const [vehiclesToRegister, setVehiclesToRegister] = useRecoilState(vehiclesToRegisterAtom);
  const appendToVehicleForms = useCallback(() => {
    setVehicleFormIdsToRegister(ids => [...ids, nanoid()]);
  }, [setVehicleFormIdsToRegister]);
  useEffect(() => {
    if (vehicleFormIdsToRegister.length === 0) appendToVehicleForms();
  }, [vehicleFormIdsToRegister.length, appendToVehicleForms]);
  useEffect(() => {
    if (vehicleFormIdsToRegister.length !== vehiclesToRegister.length) setVehiclesToRegister(vehicleFormIdsToRegister.map(() => null));
  }, [vehiclesToRegister.length, vehicleFormIdsToRegister.length, vehicleFormIdsToRegister, setVehiclesToRegister]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, vehicleFormIdsToRegister.map((id, i) => /*#__PURE__*/React.createElement(Box, {
    key: id,
    mt: 3
  }, /*#__PURE__*/React.createElement(Title, {
    isBold: true
  }, `${t('register_vehicle.choose_vehicle')} ${i + 1}:`), /*#__PURE__*/React.createElement(Box, {
    mt: 2,
    mb: 3
  }, /*#__PURE__*/React.createElement(ChooseSingleVehicle, {
    key: `choose-single-vehicle-${id}`,
    vehicleFormId: id
  })), /*#__PURE__*/React.createElement(Divider, {
    key: `divider-${id}`
  }))), /*#__PURE__*/React.createElement(Box, {
    mt: 3,
    mb: 3
  }, /*#__PURE__*/React.createElement(SecondaryButton, {
    startIcon: /*#__PURE__*/React.createElement(AddIcon, null),
    outlined: false,
    onClick: appendToVehicleForms
  }, t('register_vehicle.add_another_vehicle'))), !vehiclesUnique && /*#__PURE__*/React.createElement(InfoBox, {
    warning: true,
    mb: 3
  }, t('register_vehicle.vehicles_not_unique')));
}